<template>
    <!-- 财务管理 -->
    <div>
        <div class="finance-title">
            <div class="block-title">交易概况</div>
        </div>
        <div class="finance-top">
            <div>
                <p class="color-title fw-bold">{{summaryInfo.pvcount}}</p>
                <p class="mt-10 color-text">累计访问量
                    <el-tooltip effect="dark" content="访问各班级介绍和报名页面数量" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.totalstudentcount}}</p>
                <p class="mt-10 color-text">累计学员数
                    <el-tooltip effect="dark" content="同一个学员参加多个班级算 1 次" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.classcount}}</p>
                <p class="mt-10 color-text">累计开班数
                    <el-tooltip effect="dark" content="一个班级包括多个校区算 1 个班" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.averagestudentcount}}</p>
                <p class="mt-10 color-text">平均学员数/班
                    <el-tooltip effect="dark" content="每个班的平均学员数量，等于每个班的学员数之和/累计开班数" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.ordercount}}</p>
                <p class="mt-10 color-text">累计订单数
                    <el-tooltip effect="dark" content="学员创建订单数量，包含未支付订单" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.ordermoney}}</p>
                <p class="mt-10 color-text">累计订单金额/元
                    <el-tooltip effect="dark" content="学员创建订单对应的金额，包含未支付订单" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.ordersucccount}}</p>
                <p class="mt-10 color-text">有效订单数
                    <el-tooltip effect="dark" content="学员创建订单并且完成交易的数量，包括后续取消的订单" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.ordersuccmoney}}</p>
                <p class="mt-10 color-text">累计销售额/元
                    <el-tooltip effect="dark" content="系统开通以来累计有效销售总额" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.conversion}}</p>
                <p class="mt-10 color-text">订单转化率
                    <el-tooltip effect="dark" content="有效订单数/累计订单数" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
            <div>
                <p class="color-title fw-bold">{{summaryInfo.averagestudentprice}}</p>
                <p class="mt-10 color-text">平均学员单价/元
                    <el-tooltip effect="dark" content="累计销售额/累计学员数" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
        </div>
        <div class="finance-title mt-20">
            <div class="block-title">交易构成(班级)</div>
            <div>
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @change="getClassFinanceInfo">
                </el-date-picker>
            </div>
        </div>
        <el-table :data="classTableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="classParams.page" :pagesize="classParams.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="uprice" label="课程单价（元）" align="center" width="120" key="uprice" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.uprice}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="begindate" label="上课时间" align="center" width="250" key="begindate" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.begindate + '~' + scope.row.enddate}}
                </template>
            </el-table-column>
            <el-table-column prop="pvcount" label="访问量" align="center" width="100" key="pvcount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordercount" label="下单数" align="center" width="100" key="ordercount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordermoney" label="下单金额（元）" align="center" width="120" key="ordermoney" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.ordermoney}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="ordersucccount" label="成交单数" align="center" width="100" key="ordersucccount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordersuccmoney" label="成交金额" align="center" width="120" key="ordersuccmoney" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.ordersuccmoney}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="totalstudentcount" label="学员数" align="center" width="100" key="totalstudentcount" show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div class="finance-title mt-20">
            <div class="block-title">交易构成(校区)</div>
            <div>
                <el-date-picker v-model="date1" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @change="getCampusFinanceInfo">
                </el-date-picker>
            </div>
        </div>
        <el-table :data="campusTableData" border class="table-fixed-col" v-loading="contentLoading1" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="campusParams.page" :pagesize="campusParams.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="campusname" label="校区名称" align="center" min-width="200" key="campusname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="uprice" label="课程单价(元)" align="center" width="120" key="uprice" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.uprice}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="begindate" label="上课时间" align="center" width="250" key="begindate" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.begindate + '~' + scope.row.enddate}}
                </template>
            </el-table-column>
            <el-table-column prop="pvcount" label="访问量" align="center" width="100" key="pvcount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordercount" label="下单数" align="center" width="100" key="ordercount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordermoney" label="下单金额（元）" align="center" width="120" key="ordermoney" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.ordermoney}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="ordersucccount" label="成交单数" align="center" width="100" key="ordersucccount" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ordersuccmoney" label="成交金额" align="center" width="120" key="ordersuccmoney" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p style="text-align:right">{{scope.row.ordersuccmoney}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="totalstudentcount" label="学员数" align="center" width="100" key="totalstudentcount" show-overflow-tooltip>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import {
  getFinanceSummary,
  getCampusFinanceInfo,
  getClassFinanceInfo
} from '@/api/measApi/transactionManage.js'
import {
  getTableDefaultPageSize,
  formatMoney,
  numFormat
} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
export default {
  data() {
    return {
      summaryInfo: {
        averagestudentcount: '0',
        averagestudentprice: '0',
        classcount: 0,
        conversion: '0',
        ordercount: 0,
        ordermoney: '0',
        ordersucccount: 0,
        ordersuccmoney: '0',
        pvcount: 0,
        totalstudentcount: 0
      },
      date1: [],
      date: [],
      contentLoading1: false,
      contentLoading: false,
      isSelect: false,
      campusTableData: [],
      campusParams: {
        condition: {
          begindate: '',
          enddate: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      classTableData: [],
      classParams: {
        condition: {
          begindate: '',
          enddate: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
    }
  },
  components: {
    TableSort
  },
  created() {
    this.getFinanceSummary()
    this.getCampusFinanceInfo()
    this.getClassFinanceInfo()
  },
  methods: {
    //   获取交易概况
    getFinanceSummary() {
      getFinanceSummary().then(res => {
        if (res.code === '000') {
          this.summaryInfo = res.data
          this.summaryInfo.pvcount = numFormat(this.summaryInfo.pvcount)
          this.summaryInfo.ordermoney = formatMoney(this.summaryInfo.ordermoney)
          this.summaryInfo.ordersuccmoney = formatMoney(
            this.summaryInfo.ordersuccmoney
          )
          this.summaryInfo.averagestudentprice = formatMoney(
            this.summaryInfo.averagestudentprice
          )
        }
      })
    },
    // 获取交易构成校区
    getCampusFinanceInfo() {
      this.contentLoading1 = true
      if (this.date1 && this.date1.length > 0) {
        this.campusParams.condition.begindate = this.date1[0]
        this.campusParams.condition.enddate = this.date1[1]
      } else {
        this.campusParams.condition.enddate = ''
        this.campusParams.condition.begindate = ''
      }
      getCampusFinanceInfo(this.campusParams).then(res => {
        if (res.code === '000') {
          this.campusTableData = res.data
          this.contentLoading1 = false
          this.campusTableData.map(item => {
            item.uprice = formatMoney(item.uprice)
            item.ordermoney = formatMoney(item.ordermoney)
            item.ordersuccmoney = formatMoney(item.ordersuccmoney)
            item.pvcount = numFormat(item.pvcount)
          })
        }
      })
    },
    // 获取交易构成班级
    getClassFinanceInfo() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.classParams.condition.begindate = this.date[0]
        this.classParams.condition.enddate = this.date[1]
      } else {
        this.classParams.condition.enddate = ''
        this.classParams.condition.begindate = ''
      }
      getClassFinanceInfo(this.classParams).then(res => {
        if (res.code === '000') {
          this.classTableData = res.data
          this.contentLoading = false
          this.classTableData.map(item => {
            item.uprice = formatMoney(item.uprice)
            item.ordermoney = formatMoney(item.ordermoney)
            item.ordersuccmoney = formatMoney(item.ordersuccmoney)
            item.pvcount = numFormat(item.pvcount)
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.finance-title {
  height: 40px;
  background: #f6f7fb;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ::v-deep .el-date-editor {
    .el-range__icon {
      line-height: 25px;
    }
    .el-range-separator {
      line-height: 25px;
    }
  }
}
.finance-top {
  height: 195px;
  background: #f6f7fb;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 16%;
    margin-top: 20px;
    > p {
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>

